<!-- <mat-icon class="close" (click)="close()">close</mat-icon> -->
<div>
    <mat-drawer-container [hasBackdrop]="false" autosize style="height: calc(100vh - 50px); width:100%">
        <mat-drawer #drawer mode="side" opened style="display: block;">
            <div class="heading"></div>
            <mat-tab-group>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span (click)="onTabChange('Folder')">Folders</span>
                    </ng-template>
                    <ng-template matTabContent>                        
                        <div *ngIf="!noFolders">
                            <div class="input-group-sm mt-2 input-group col-12">
                            <input
                                class="form-control"
                                type="search"
                                (keyup)="applyFilterOnFolders($event)"
                                (search)="applyFilterOnFolders($event)"
                                placeholder="Filter folder name"
                            />
                            </div>
                        </div>
                        <div class="clearfix mt-1 mr-1"><button mat-stroked-button (click)="createFolder()" class="float-right pr-2">
                                <mat-icon>add</mat-icon> New
                            </button>
                        </div>
                        <div class="m-2 text-center" *ngIf="noFolders">
                            No Folders to view
                        </div>
                        <mat-tree *ngIf="!noFolders" [dataSource]="virtualFolders" [treeControl]="treeControl">
                            <!-- This is the tree node template for leaf nodes -->
                            <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [matTreeNodePaddingIndent]="20">
                                <!-- use a disabled button to provide padding for tree leaf -->
                                <button mat-icon-button matTreeNodeToggle style="min-width: 20px;" [attr.aria-label]="'toggle ' + node.folder_name">
                                    <mat-icon class="mat-icon-rtl-mirror">
                                        {{treeControl.isExpanded(node) ? 'folder_open' : 'folder_open'}}
                                    </mat-icon>
                                </button>
                                <button [ngClass]="node.id === selectedFolderId ? 'bold-text' : 'normal-text'" mat-button (click)="selectFolder(node.folder_name, node.id)">
                                        {{node.folder_name}}
                                </button>
                            </mat-tree-node>
                            <!-- This is the tree node template for expandable nodes -->
                            <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding
                                [matTreeNodePaddingIndent]="20">
                                <button mat-icon-button matTreeNodeToggle style="min-width: 20px;" [attr.aria-label]="'toggle ' + node.folder_name">
                                    <mat-icon class="mat-icon-rtl-mirror">
                                        {{treeControl.isExpanded(node) ? 'folder_open' : 'folder'}}
                                    </mat-icon>
                                </button>
                                <button [ngClass]="node.id === selectedFolderId ? 'bold-text' : 'normal-text'" mat-button (click)="selectFolder(node.folder_name, node.id)">
                                    {{node.folder_name}}</button>
                            </mat-tree-node>
                        </mat-tree>
                    </ng-template>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span (click)="onTabChange('Team')">Teams</span>   
                    </ng-template>
                    <ng-template matTabContent>                        
                        <div *ngIf="!noTeams">
                            <div class="input-group-sm mt-2 input-group col-12">
                            <input
                                class="form-control"
                                type="search"
                                (keyup)="applyFilterOnTeams($event)"
                                (search)="applyFilterOnTeams($event)"
                                placeholder="Filter Team name"
                            />
                            </div>
                        </div>                        
                        <div class="m-2 text-center" *ngIf="noTeams">
                            No Teams to view
                        </div>
                        <mat-tree *ngIf="!noTeams" [dataSource]="virtualTeams" [treeControl]="teamTreeControl">
                            <!-- This is the tree node template for leaf nodes -->
                            <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [matTreeNodePaddingIndent]="20">
                                <!-- use a disabled button to provide padding for tree leaf -->
                                <button mat-icon-button matTreeNodeToggle style="min-width: 20px;" [attr.aria-label]="'toggle ' + node.folder_name">
                                    <mat-icon class="mat-icon-rtl-mirror">
                                        {{treeControl.isExpanded(node) ? 'folder_open' : 'folder_open'}}
                                    </mat-icon>
                                </button>
                                <button [ngClass]="node.id === selectedTeamId ? 'bold-text' : 'normal-text'" mat-button (click)="selectTeam(node.folder_name, node.id, node.type, node.team_id)">
                                        {{node.folder_name}}
                                </button>
                            </mat-tree-node>
                            <!-- This is the tree node template for expandable nodes -->
                            <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding
                                [matTreeNodePaddingIndent]="20">
                                <button mat-icon-button matTreeNodeToggle style="min-width: 20px;" [attr.aria-label]="'toggle ' + node.folder_name">
                                    <mat-icon class="mat-icon-rtl-mirror">
                                        {{treeControl.isExpanded(node) ? 'folder_open' : 'folder'}}
                                    </mat-icon>
                                </button>
                                <button [ngClass]="node.id === selectedTeamId ? 'bold-text' : 'normal-text'" mat-button (click)="selectTeam(node.folder_name, node.id, node.type, node.team_id)">
                                    {{node.folder_name}}</button>
                            </mat-tree-node>
                        </mat-tree>
                    </ng-template>                    
                </mat-tab>
            </mat-tab-group>
            
        </mat-drawer>

        <mat-drawer-content>
            <div class="card m-2" *ngIf="!folderSelected && !isMainPage && !noDocuments && !hideDocList">
                <div class="card-body"><strong>Please select a folder</strong><br> 1. To view the documents
                    associated with it.<br>
                </div>
            </div>

            <div class="m-2">
                <div *ngIf="docResultsList && folderSelected && !isMainPage && !noDocuments && !teamSelectMessage">
                    <mat-paginator #myPaginator [pageSizeOptions]="[50, 100]" [pageSize]="50" (page)="selectPage($event)" class="custom-paginator" showFirstLastButtons>
                    </mat-paginator>
                </div>
                <div *ngIf="folderSelected && !isMainPage && !hideDocList">
                    <div class="Tabletitle">Document List - {{selectedFolderName}}
                        ({{totalDocumentCount|number}})

                    </div>

                    <div class="btn-group fit-content mt-2 mb-2">
                        <button *ngIf="selectedTab == 'Folder'" class="btn pr-2" mat-stroked-button
                            (click)="updateFolder(selectedFolderId)">
                            <mat-icon class="mb-1">edit</mat-icon> Update
                        </button>
                        <button *ngIf="selectedTab == 'Folder'" class="btn pr-2" mat-stroked-button (click)="createSubFolder()">
                            <mat-icon class="mb-1">add</mat-icon> Sub Folder
                        </button>
                        <button *ngIf="selectedTab == 'Folder'" class="btn pr-2" mat-stroked-button (click)="deleteFolder()">
                            <mat-icon class="mb-1">add</mat-icon> Delete Folder
                        </button>                        
                        <span *ngIf ="selectedTab == 'Folder'" class="fill-remaining-space col-1"></span>
                        <button *ngIf="selectedTab == 'Folder'" style="vertical-align: middle;" class="actionButton col-1" mat-raised-button (click)="uploadCaptureDocument()">
                            <mat-icon>cloud_upload</mat-icon> Upload
                        </button>
                        <span class="fill-remaining-space col-1"></span>
                        <button *ngIf="selection.selected.length>0 && selectedTab == 'Folder'" style="vertical-align: middle;" class="actionButton col-1" mat-raised-button #authMenu
                            [matMenuTriggerFor]="menu">Actions
                            <mat-icon>arrow_drop_down</mat-icon>
                        </button>                               
                        <mat-menu class="my-menu" #menu="matMenu">
                            <button mat-menu-item (click)="deleteDocument()">Delete Documents</button>
                            <button *ngIf="teamList.length > 0" mat-menu-item [matMenuTriggerFor]="assignOwner">Assign Team</button>
                        </mat-menu>
                        <mat-menu #assignOwner="matMenu">
                            <button mat-menu-item *ngFor="let team of teamList" [value]="team.team_name"
                            (click)="assignTeam(team)"><mat-icon>team</mat-icon>{{team.team_name}}</button>
                        </mat-menu>
                        <!-- <mat-menu #assignTeam="matMenu">
                            <button mat-menu-item *ngFor="let team of teamList" [value]="team.team_name"
                            (click)="assignTeam(team)"><mat-icon>team</mat-icon>{{team.team_name}}</button>            
                        </mat-menu>                                         -->
                    </div>

                    <div *ngIf="noDocuments" class="text-center mt-2">
                        There are no files uploaded for index
                    </div>
                    <div *ngIf="selectedTab == 'Team' && teamSelectMessage" class="text-center mt-2">
                        Select folders to view the files
                    </div>
                </div>
                <div *ngIf="docResultsList && folderSelected && !isMainPage && !noDocuments && !teamSelectMessage">
                    <table aria-describedby="doc-table" mat-table [dataSource]="docResultsList" matSort>

                        <!-- <ng-container matColumnDef="select">
                            <th id="select" mat-header-cell *matHeaderCellDef> </th>
                            <td mat-cell *matCellDef="let row">
                            </td>
                        </ng-container> -->
                        <ng-container *ngIf ="selectedTab == 'Folder'" matColumnDef="select">
                            <th id="select" mat-header-cell *matHeaderCellDef>
                                <input type="checkbox" 
                                    [checked]="selection.selected.length > 0" 
                                    [indeterminate]="selection.selected.length > 0 &&
                                    selection.selected.length < documents.length" 
                                    (change)="onCheckAllChange($event)" />
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <mat-checkbox (click)="$event.stopPropagation()"
                                    (change)="$event ? selection.toggle(element) : null"
                                    [checked]="selection.isSelected(element)" [aria-label]="checkboxLabel(element)">
                                </mat-checkbox>
                            </td>
                        </ng-container>

                        <ng-container  matColumnDef="documentName">
                            <th id="documentName" mat-header-cell *matHeaderCellDef mat-sort-header> File Name </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.documentName}}
                            </td>
                        </ng-container>
                        <ng-container   matColumnDef="filesize">
                            <th id="filesize"  mat-header-cell *matHeaderCellDef mat-sort-header> File Size </th>
                            <td mat-cell *matCellDef="let element"> {{element.filesize}} </td>
                        </ng-container>
                        <!-- <ng-container matColumnDef="createdDate">
                            <th id="createdDate"  mat-header-cell *matHeaderCellDef mat-sort-header> Uploaded date </th>
                            <td mat-cell *matCellDef="let element"> {{element.createdDate | date }} </td>
                        </ng-container>
                        <ng-container  matColumnDef="created_by">
                            <th id="created_by"  mat-header-cell *matHeaderCellDef mat-sort-header> Uploaded By </th>
                            <td mat-cell *matCellDef="let element"> {{element.created_by }} </td>
                        </ng-container>                         -->
                        <!-- dynamic columns -->
                        <ng-container *ngFor="let column of documentCols">
                            <ng-container *ngIf="column.indexOf('display_') === 0" matColumnDef="{{column}}">
                                <th id="{{column | stripDisplay}}" mat-header-cell *matHeaderCellDef mat-sort-header>
                                    {{column | stripDisplay}} </th>
                                <td mat-cell *matCellDef="let element"> {{ element[column] }} </td>
                            </ng-container>
                        </ng-container>
                        <!-- end dynamic columns-->

                        <tr mat-header-row *matHeaderRowDef="documentCols"></tr>
                        <!-- <tr mat-row *matRowDef="let row; columns: documentCols;" class="element-row">
                        </tr> -->
                        <tr mat-row *matRowDef="let row; columns: documentCols;" (click)="viewDocument(row)"
                            class="element-row" [class.selected-row]="selectedRow === row"
                            (click)="selectedRow = selectedRow === row ? null : row"
                            title="Select Document">
                        </tr>
                    </table>                    
                </div>
                <div *ngIf="isMainPage && !hideDocList">
                    <app-dialog-folders-config [isUpdateFolder]="isUpdateFolder" [selectedFolderId]="selectedFolderId"
                        [isCreateFolder]="isCreateFolder" [isCreateSubFolder]="isCreateSubFolder"
                        (isMainPage)="onReturnPage($event)" (alertErrorMessage)="alertErrorMessage($event)"></app-dialog-folders-config>
                </div>                
            </div>
        </mat-drawer-content>
    </mat-drawer-container>
</div>